import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import EditFundraisingPage from 'src/components/Pages/EditFundraisingPage';

const EditFundraisingModal = () => (
  <ModalBase
    name={MODALS.editFundraising}
    size={MODALS_SIZE.medium}
    form={FORM.fundraising}>
    <EditFundraisingPage />
  </ModalBase>
);

export default EditFundraisingModal;
